export default {
  title: 'Ontdek iets wat je lekker vindt!',
  description: 'Je bestellingen worden hier weergegeven.',
  buttons: {
    order_now: 'Bestel nu',
  },
};
